export default "__VITE_ASSET__ksVbTTiL__"